export const basicStyles = {
    backgroundColor: "#262626",
    border: "1px solid #1f1f1f",
};
